import { Badge, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ScanStatus } from '../contexts/constants';

/**
 * スキャン状態ごとの表示定義（表示不要な状態はここに含めない）
 * LEGACY（GuardDuty導入前の既存ファイル）は従来通りバッジを出さない。
 */
const BadgeDefinitions: Record<string, { colorScheme: string; key: string }> = {
  [ScanStatus.Threat]: { colorScheme: 'red', key: 'threat' },
  [ScanStatus.Scanning]: { colorScheme: 'yellow', key: 'scanning' },
  [ScanStatus.Clean]: { colorScheme: 'green', key: 'clean' },
  [ScanStatus.Failed]: { colorScheme: 'gray', key: 'incomplete' },
  [ScanStatus.Unsupported]: { colorScheme: 'gray', key: 'incomplete' },
  [ScanStatus.AccessDenied]: { colorScheme: 'gray', key: 'incomplete' },
  [ScanStatus.Unknown]: { colorScheme: 'gray', key: 'incomplete' },
  [ScanStatus.Disabled]: { colorScheme: 'blue', key: 'unscanned' },
};

/**
 * マルウェアスキャン状態バッジ
 * 既存ファイル（LEGACY）・状態未取得の場合は何も表示しない
 * @param scanStatus バックエンドから取得したスキャン状態
 * @returns スキャン状態バッジ
 */
const ScanStatusBadge: React.FC<{ scanStatus?: string | null }> = ({ scanStatus }) => {
  const { t } = useTranslation();

  if (!scanStatus) return null;

  const definition = BadgeDefinitions[scanStatus];
  if (!definition) return null;

  return (
    <Tooltip label={t(`components.ScanStatusBadge.message.${definition.key}`)} hasArrow>
      <Badge colorScheme={definition.colorScheme} fontSize="xs">
        {t(`components.ScanStatusBadge.label.${definition.key}`)}
      </Badge>
    </Tooltip>
  );
};

export default ScanStatusBadge;
